import { useState, useEffect } from 'react';
import { fetchPayAccount } from '../services/PayAccountService';
import { PayAccount } from '../models/PayAccount';

export function usePayAccount() {
  const [payAccount, setPayAccount] = useState<PayAccount | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetchPayAccount()
      .then((data) => {
        setPayAccount(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  return { payAccount, loading, error };
}
